import { render, staticRenderFns } from "./GroupManagement.vue?vue&type=template&id=6ca2f853"
import script from "./GroupManagement.vue?vue&type=script&lang=ts"
export * from "./GroupManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca2f853')) {
      api.createRecord('6ca2f853', component.options)
    } else {
      api.reload('6ca2f853', component.options)
    }
    module.hot.accept("./GroupManagement.vue?vue&type=template&id=6ca2f853", function () {
      api.rerender('6ca2f853', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/groups/GroupManagement.vue"
export default component.exports